import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { UserContext } from 'Context/user';
import { VehicleLookupContext } from 'Context/vehicleLookup';

import { ComponentsWrapper } from 'Layout';

import { Content } from 'LegacySBCRA/Content/Content';
import { HeaderLinkProps } from 'Storybook/components/local/VehicleHeader';
import { VehicleHeader } from 'Storybook/components/local/VehicleHeader/VehicleHeader';

import PageLoader from '../../../../components/transitions/PageLoader/PageLoader';
import { useAuthUI } from '../../experiments/useAuthUI/useAuthUI';
import Loader from '../valuations/components/Loader';

import LocalTexts from './VehicleHeaderWrapperTexts.json';

import styles from './VehicleHeaderWrapper.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string) => LocalT.translate(key) as string;

type VehicleHeaderWrapperProps = {
  animate?: boolean;
  link?: HeaderLinkProps | null;
  loading?: boolean;
};

type HistoryState = {
  animate?: boolean;
  animateFromNewHomePage?: boolean;
} | null;

const VehicleHeaderWrapper = ({
  animate = false,
  link = {
    label: t('changeVehicle'),
    to: '/',
  },
  loading = false,
}: VehicleHeaderWrapperProps) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { userState } = useContext(UserContext);
  const user = Number.isInteger(userState?.id);
  const { isAuthUIJourney } = useAuthUI();

  const history = useHistory<HistoryState>();
  const { animate: transitView } = history?.location?.state ?? {};

  if (!user && isAuthUIJourney) {
    return (<></>);
  }

  return (
    <>
      {
        (vehicle?.id) ? (
          <>
            <div
              className={cx(styles.vehicleHeader)}
            >
              <div className={styles.vehicleInner}>
                <Content className={styles.content}>
                  <VehicleHeader
                    link={link ?? null}
                    {...{ vehicle }}
                  />
                </Content>
              </div>
            </div>
            {
              loading && (
                // @ts-ignore
                <ComponentsWrapper className={cx({ [styles.loaderHidden]: transitView && !animate })}>
                  <Loader />
                </ComponentsWrapper>
              )
            }
          </>
        ) : (
          <>
            { loading && <PageLoader /> }
          </>
        )
      }
    </>
  );
};

export default VehicleHeaderWrapper;
